import useIntegrations from './useIntegrations';

export default useIntegrations;
